module.exports = __webpack_public_path__ + "img/52.c844e199.jpg";